import { BehaviorSubject, Observable } from 'rxjs';


/**------------------------------------------------------
 * User Info
 */
export class TokensStateHelper {

	//** User Info */
	private readonly tokensInfo$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	public tokenBalance$: Observable<number> = this.tokensInfo$.asObservable(); // Expose as Observable


	/**------------------------------------------------------
	 * Token Info Helper
	 */
	setTokensInfo(tokens: number): void {
		this.tokensInfo$.next(tokens);
	}

	getBalanceToken(): number {
		return this.tokensInfo$.getValue();
	}

	resetTokens(): void {
		this.setTokensInfo(0);
	}
}
